(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('MyIDDialogController', MyIDDialogController);

    MyIDDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'MyID', 'Customer'];

    function MyIDDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, MyID, Customer) {
        var vm = this;

        vm.myID = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.customers = Customer.query();
        vm.onIssuedDateChange = onIssuedDateChange;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.myID.id !== null) {
                MyID.update(vm.myID, onSaveSuccess, onSaveError);
            } else {
                MyID.save(vm.myID, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:myIDUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.birthDate = false;
        vm.datePickerOpenStatus.issuedDate = false;
        vm.datePickerOpenStatus.expiryDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function onIssuedDateChange() {
            if (vm.myID.issuedDate) {
                const issued = new Date(vm.myID.issuedDate);
                const expiry = new Date(issued);
                expiry.setFullYear(expiry.getFullYear() + 10);
                expiry.setDate(expiry.getDate() - 1);
                vm.myID.expiryDate = expiry;
            }
        }
    }
})();
